import type { Theme } from '@mui/material/styles';

export const useListsStyle = (theme: Theme) => {
  return {
    followToggle: {
      miniEcard: {
        width: '100%',
        borderRadius: '8px',
        backgroundColor: '#77777722',
        textAlign: 'left',
        alignItems: 'center',
        p: 1,
        gap: 1,
      },
      miniEcardAvatar: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
      },
      miniEcardInfo: {
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      },
      miniEcardRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        minWidth: 0,
      },
      miniEcardIcon: {
        color: theme.palette.text.secondary,
        flexShrink: 0,
        fontSize: '18px',
      },
      miniEcardValue: {
        fontSize: '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflowWrap: 'anywhere',
      },
      customFields: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      },
      customFieldRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0.25,
        px: 2,
        py: 1.25,
        borderRadius: '8px',
        backgroundColor: '#77777722',
      },
      customFieldLabel: {
        fontSize: '13px',
        color: theme.palette.text.secondary,
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
      },
      customFieldValue: {
        fontSize: '13px',
        fontWeight: 600,
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
      },
      actionBtn: {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: 1.5,
        borderRadius: '8px',
        height: '36px',
        minHeight: '36px',
        py: 0,
        px: 1.5,
        boxShadow: 'none',
        whiteSpace: 'nowrap',
        '&:hover': { boxShadow: 'none' },
        // Uniform icon size across contained + outlined buttons
        '& .MuiButton-startIcon, & .MuiButton-endIcon': {
          '& .MuiIcon-root, & svg': {
            fontSize: '18px',
            width: '18px',
            height: '18px',
          },
        },
      },
      linkedInBtn: {
        backgroundColor: '#0A66C2',
        '&:hover': { backgroundColor: '#054399' },
      },
      viewProfileBtn: {
        borderWidth: '1.5px',
        '&:hover': { borderWidth: '1.5px' },
      },
    },
  };
};
